import { Outlet } from 'react-router-dom'
import Navbar from '../components/Navbar'
import { SiteFooter } from '../components/home/SiteFooter'
import { LoginModalProvider } from '../contexts/LoginModalContext'

const MainLayout = () => {
  return (
    <LoginModalProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Outlet />
        </main>
        <SiteFooter />
      </div>
    </LoginModalProvider>
  )
}

export default MainLayout

